import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { SelectRole } from 'pages';
import { AppRoutes } from 'router';
import { secretStorage } from "config";
import { useSelector } from "react-redux";

const RoleRoutes = () => {
    const { defaultRole } = useSelector(state => state.user);
    const { user_data, default_user_roles } = secretStorage.getItem("user") || {};
    const location = useLocation();

    // Redirect to /select-role if needed, but NOT if already there
    if (
        user_data &&
        user_data.length > 1 &&
        !default_user_roles &&
        location.pathname !== "/select-role"
    ) {
        return <Navigate to="/select-role" replace />;
    }

    return (
        <Routes>
            <Route path="/select-role" element={<SelectRole />} />
            <Route path="/*" element={<AppRoutes />} />
        </Routes>
    );
};

export default RoleRoutes;